import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, Platform, TouchableOpacity } from 'react-native';

import Theme from '../../theme';
import { Avatar, Heading, HeadingTypes } from '../../components';
import { Tile } from '../../ui/components';
import Friend from '../components/Friend';
import { Icon } from '../../components';
import { defaultScale } from '../../utils/scaling';

const PrivacyPartnerCard = ({
    t,
    block,
    index,
    remove,
    unblock,
    partner,
    listType,
    isLoading,
    isPrivate,
    invertColours,
    addToWhitelist,
    openProfile,
}) => {
    let buttonTitle = isPrivate ? t('remove') : t('block');
    let onPress = isPrivate ? remove : block;

    if (partner.listType === 'blacklist') {
        buttonTitle = t('unblock');
        onPress = unblock;
    } else if (partner.listType === 'searchlist') {
        buttonTitle = t('add');
        onPress = addToWhitelist;
    } else if (partner.listType === 'whitelist') {
        buttonTitle = t('remove');
        onPress = remove;
    }

    let overrideStyles = {};
    let avatarColour = Theme.CHARCOAL;
    if (invertColours && Platform.OS === 'web') {
        avatarColour = Theme.GREY_LIGHT;
        overrideStyles = invertColorStyles;
    }
    const nickname = partner.nickname ? `(${partner.nickname})` : ''
    return (
        <View style={styles.tileContainer}>
            <Tile customStyle={[styles.container]} onPress={() => openProfile(partner.listType, partner, onPress, isLoading, block, unblock)}>
                <View style={styles.profileContainer}>
                    <Avatar
                        avatarId={partner.uid}
                        iconColor={avatarColour}
                    />
                    <View style={styles.profileDetailsContainer}>
                        <View style={{ flexDirection: 'row' }}>
                            <Heading
                                title={`${partner.fullname} ${nickname}`}
                                style={[styles.fullname, overrideStyles.fullname]}
                                headerType={HeadingTypes.HEADING_TWO}
                            />
                            {partner.listType === 'searchlist' &&
                                <Friend t={t} status={'friend'} />
                            }
                            {partner.listType === 'blacklist' &&
                                <Friend t={t} status={'blocked'} />
                            }
                        </View>
                    </View>
                </View>
                <View style={styles.buttonContainer}>

                    <TouchableOpacity
                        disabled={isLoading}
                        style={{ alignSelf: 'flex-end' }}
                        onPress={() => openProfile(partner.listType, partner, onPress, isLoading, block, unblock)}>
                        <Icon
                            size={defaultScale(20)}
                            color={Theme.GREY_DARK_MEDIUM_DARK}
                            name='ios-arrow-forward'
                        />
                    </TouchableOpacity>
                </View>
            </Tile>
        </View>
    );
}

PrivacyPartnerCard.propTypes = {
    t: PropTypes.func.isRequired,
    block: PropTypes.func,
    remove: PropTypes.func,
    unblock: PropTypes.func,
    invertColours: PropTypes.bool,
    partner: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    addToWhitlist: PropTypes.func,
    listType: PropTypes.oneOf(['whitelist', 'blacklist', 'searchlist']).isRequired,
};

const invertColorStyles = StyleSheet.create({
    fullname: {
        color: Theme.GREY_LIGHT,
    },
});

const styles = StyleSheet.create({
    tileContainer: { paddingLeft: 20, paddingRight: 20 },
    container: {
        padding: 10,
        borderTopWidth: 0.5,
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        borderTopColor: Theme.GREY,
        backgroundColor: 'white',
    },
    profileContainer: {
        flex: 0.6,
        flexDirection: 'row',
    },
    profileDetailsContainer: {
        paddingLeft: 10,
        paddingRight: 10,
        justifyContent: 'center',
    },
    buttonContainer: {
        flex: 0.4,

        fontFamily: Theme.CustomBold,
        alignItems: 'flex-end',
    },
    fullname: {
        color: Theme.BLACK,
        flexDirection: 'row'
    },
    nickname: {
        fontFamily: Theme.CustomNormalItalic,
        color: Theme.GREY_MEDIUM,
    },
    buttonText: {

        fontFamily: Theme.CustomBold,
        color: Theme.PRIMARY,
        textAlign: 'right',
    },
});

export default PrivacyPartnerCard
